<div class="modal-header approval-list-header">
    <div class="approval-list-heading">
        <span class="approval-list-heading__icon">
            <lucide-icon name="history" [size]="19"></lucide-icon>
        </span>
        <div class="approval-list-heading__copy">
            <h5 class="modal-title" id="approval-list-title">{{ 'COMMON.APPROVAL_LIST.PREVIOUS_APPROVALS' | translate }}</h5>
            <span class="approval-list-subtitle" *ngIf="title">{{ title }}</span>
        </div>
    </div>
    <button type="button" class="close approval-list-close" (click)="close()"
            [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body approval-list-body" tabindex="0">
    <app-ryd-formulas-approval-list [isModal]="true"
                                    [menuId]="menuId"
                                    [objectId]="objectId"
                                    [statusChange]="statusChange"></app-ryd-formulas-approval-list>
</div>

<div class="modal-footer approval-list-footer">
    <button type="button" class="btn btn-outline-primary approval-list-action" rippleEffect (click)="close()">
        <lucide-icon name="x" [size]="16"></lucide-icon>
        <span>{{ 'COMMON.BUTTONS.CLOSE' | translate }}</span>
    </button>
</div>
